import { Permission } from "shared/types/permission.enum";
import { to } from "routing/to";
import { AccountMenuRouteConfig } from "./navigation.types";

export const accountMenuConfig: AccountMenuRouteConfig[] = [
  {
    path: to.account,
    translationKey: "navigation.accountMenu.accountSettings",

    requiredPermission: Permission.USER
  },
  {
    path: to.questionnaire,
    translationKey: "navigation.accountMenu.startingWithUptain",

    badgeKey: "questionnaireIncomplete",
    requiredPermission: Permission.USER
  },
  {
    path: to.shopLinks,
    translationKey: "navigation.accountMenu.links",

    requiredPermission: Permission.USER
  },
  {
    path: to.contactPersons,
    translationKey: "navigation.accountMenu.contactPersons",

    requiredPermission: Permission.USER
  }
];
